import { ReactNode, useMemo } from "react";
import { RulesetRegistry } from "../../domain/ruleset-registry";
import { rulesetDatas } from "../../rulesets";
import { useDatabase } from "../database-provider";
import { RulesetsContext } from "./context";

export function RulesetProvider(props: { children: ReactNode }) {
  const db = useDatabase();
  const rulesets = useMemo(() => new RulesetRegistry(rulesetDatas, db), [db]);

  return (
    <RulesetsContext.Provider value={rulesets}>
      {props.children}
    </RulesetsContext.Provider>
  );
}
